import { AppShell, Container, Flex, ScrollArea } from "@mantine/core";
import { useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import { GridAsymmetrical } from "../components/GridAsymmetrical/GridAsymmetrical";
import ProfileSection from "../components/ProfileSection/ProfileSection";
import { NavbarSimple } from "../components/NavbarSimple/NavbarSimple";
import { TableSort } from "../components/TableSort/TableSort";
import {
  FilterResetProvider,
  useFilterReset,
} from "../components/TableSort/FilterGroup/FilterResetContext";
import { GridPageType, PageType } from "../types/types";
import MerchLogo from "../components/MerchLogo/MerchLogo";

export default function HomePage() {
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const [pageType, setPageType] = useState<PageType>("products");

  function handleCLick(clickedType: PageType) {
    console.log("handle click", clickedType);
    setPageType(clickedType);
  }

  function isGridType(t: PageType): t is GridPageType {
    return t === "subscriptions" || t === "products";
  }

  return (
    <AppShell
      padding="md"
      header={{ height: 110 }} 
      navbar={{
        width: 300,
        breakpoint: "sm",
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      aside={{
        width: 300,
        breakpoint: "md",
        collapsed: { desktop: false, mobile: true },
      }}
      
    >
      <FilterResetProvider>

      <AppShell.Header>
        <MerchLogo />
      </AppShell.Header>

      
        <AppShell.Navbar>
          <NavbarSimple onSelect={handleCLick} />
        </AppShell.Navbar>
        <AppShell.Main>
          <ScrollArea>
            {isGridType(pageType) ? (
              <GridAsymmetrical type={pageType}></GridAsymmetrical>
            ) : (
              <TableSort type={pageType} />
            )}
          </ScrollArea>
        </AppShell.Main>

        <AppShell.Aside p="md">
          <ProfileSection></ProfileSection>
        </AppShell.Aside>
      </FilterResetProvider>
    </AppShell>
  );
}
